/* Women reciters are for sisters only (Settings → Profile → "A sister").
   Brothers and "prefer not to say" don't see or play them. One rule, used by
   every list, the reciter pages, resume, and the player itself. */
import { useSettings } from '@/lib/store';
import type { Reciter } from '@/data/reciters';
import type { Settings } from '@/lib/types';

export const DEFAULT_RECITER = 'alafasy';

export const canHear = (r: Pick<Reciter, 'gender'>, gender: Settings['gender']) => r.gender !== 'female' || gender === 'female';

/** `(r) => boolean` for the current profile. */
export function useCanHear() {
  const gender = useSettings((s) => s.settings.gender);
  return (r: Pick<Reciter, 'gender'>) => canHear(r, gender);
}
